module.exports = __webpack_public_path__ + "static/media/as_airdrop_icon.85a35bf7.png";